import React from "react";
import styles from './curriculum.module.css'
import {AgeGroupActivityItem} from "./types";


const AgeGroupItem:  React.FC<AgeGroupActivityItem> =  ({group, description, activities, extraDescription, extraActivities}) => {

    return (
        <article className={styles.testimonial_card}>
            <h2 className={styles.group}>{group}</h2>
            <p className={styles.description}>{description}</p>
            <p className={styles.act_title}>Parmi les activités proposées:</p>
            <ul className={styles.activity_list}>
                {activities.map((activity, index) => (
                    <li key={index} className={styles.activity_item}>
                        {activity}
                    </li>
                ))}
            </ul>
            {extraDescription && (
                <>
                    <p className={styles.description}>{extraDescription}</p>
                    <p className={styles.act_title}>Parmi les activités proposées:</p>
                    <ul className={styles.activity_list}>
                        {extraActivities?.map((activity, index) => (
                             <li key={index} className={styles.activity_item}>
                                {activity}
                            </li>
                        ))}
                    </ul>
                </>
            )}
        </article>

    );
};

export default AgeGroupItem;
